export const strings = {
    "saveBtnTooltip": "Prenota ora",
    "deleteAllBtnTooltip": "Cancella la lista",
    "deleteBtnTooltip": "Elimina dalla lista",
    "relatedProductsTitle": "Guarda anche:", 
}